import PropTypes from 'prop-types';
import { getDateSearchText } from './logSearchUtils';

LogSearchEntry.propTypes = {
  entryKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  hidden: PropTypes.bool,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  searchText: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
};

// Wraps one log entry for useLogSearch. searchText is for content that isn't in
// the entry's rendered text (tooltips, dialogs) but should still be searchable.
export default function LogSearchEntry({ entryKey, hidden, date, searchText = [], children }) {
  const extraText = [getDateSearchText(date), ...searchText].filter(Boolean).join(' ');
  return (
    <div data-log-entry={entryKey} style={hidden ? { display: 'none' } : undefined}>
      {children}
      {extraText && <span hidden data-log-search-text> {extraText}</span>}
    </div>
  );
}
